import React, { useEffect, useState } from "react";
import { RegContentWrapper, RegistrationWrapper } from "./Styled";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import {
  Box,
  ButtonStyledTb,
  FormButtonStyled,
  HeadingStyled,
  HeadingStyledSm,
} from "../../../components/styled/Elements";
import { Form } from "react-bootstrap";
import CustomProgressBar, {
  MultiStepProgressBar,
} from "./MultiStepProgressBar";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import ProfileRejected from "./UnderReview";
import UnderReview from "./UnderReview";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import UsersApi from "../../../services/api/usersApi";
import { useUser } from "../../../context/userContext";
import { useNavigate } from "react-router-dom";
import { getFormattedTime, reqFormatDate } from "../../../utils";
import MainHeader from "../../../components/header/MainHeader";
import { AvatarPlaceholders } from "../../../components/styled/AllImages";
import { toast } from "react-toastify";

const Registration = () => {
  const userJson = localStorage.getItem("userInfo");
  const user = JSON.parse(userJson);
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { fetchUserInfo } = useUser();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [cities, setCities] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(AvatarPlaceholders);
  const {
    register,
    handleSubmit,
    trigger,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const next = async () => {
    const isValid = await trigger();
    if (isValid) setCurrentStep((prev) => prev + 1);
  };
  const prev = () => setCurrentStep((prev) => prev - 1);

  const steps = [
    {
      title: t("STEP") + " 1",
      heading: t("PersonalInformation"),
      status: currentStep === 1 ? t("InProgress") : t("Completed"),
    },
    {
      title: t("STEP") + " 2",
      heading: t("FALInformation"),
      status:
        currentStep === 2
          ? t("InProgress")
          : currentStep > 2
          ? t("Completed")
          : t("Pending"),
    },
    {
      title: t("STEP") + " 3",
      heading: t("ContactDetails"),
      status:
        currentStep === 3
          ? t("InProgress")
          : currentStep > 3
          ? t("Completed")
          : t("Pending"),
    },
    {
      title: t("STEP") + " 4",
      heading: t("WebSocialMedia"),
      status:
        currentStep === 4
          ? t("InProgress")
          : currentStep > 4
          ? t("Completed")
          : t("Pending"),
    },
  ];

  useEffect(() => {
    if (user) {
      reset({
        name: user?.name,
        email: user?.email,
        phone: user?.phone,
        contact_phone: user?.phone,
        contact_email: user?.email,
      });
    }
  }, []);

  const getCities = async () => {
    try {
      const { data, code } = await UsersApi.getCitiesList();
      if (code === 200 && data?.length > 0) {
        const citiesData = data.map((city) => ({
          ...city,
          value: city?.id,
          label: language === "en" ? city?.name_en : city?.name_ar,
        }));
        setCities(citiesData);
        localStorage.setItem("citiesList", JSON.stringify(citiesData));
      }
    } catch (error) {}
  };
  const getProvinces = async () => {
    try {
      const { data, code } = await UsersApi.getProvincesList();
      if (code === 200 && data?.length > 0) {
        setProvinces(
          data.map((province) => ({
            value: province?.id,
            label: language === "en" ? province?.name_en : province?.name_ar,
          }))
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    getCities();
    getProvinces();
  }, [language]);

  const onSubmit = async (dataObj) => {
    try {
      setLoading(true);
      const formData = new FormData();
      Object.entries(dataObj).forEach(([key, value]) => {
        if (key === "contact_office_phone" && !value) return;
        if (key === "fal_exp_date")
          formData.append(key, `${reqFormatDate(value)}`);
        else if (key === "we_operate_in") {
          console.log(key, value);

          formData.append(key, JSON.stringify(value));
        } else formData.append(key, value);
      });
      const { code, message } = await UsersApi.completeProfile(formData);
      if (code === 200) {
        toast.success(t("profile_completed_successfully"));
        await fetchUserInfo();
        navigate("/my-profile");
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <RegistrationWrapper>
        <MainHeader />
        <Box className="registartionHeader">
          <HeadingStyled size="24px">{t("CompleteRegistration")}</HeadingStyled>
        </Box>
        <RegContentWrapper>
          <Box className="RegContentContainer">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <CustomProgressBar currentStep={currentStep} steps={steps} />
              {currentStep === 1 && (
                <Step1
                  register={register}
                  control={control}
                  errors={errors}
                  cities={cities}
                  provinces={provinces}
                  watch={watch}
                  profileImage={profileImage}
                  setProfileImage={setProfileImage}
                />
              )}
              {currentStep === 2 && (
                <Step2
                  register={register}
                  control={control}
                  errors={errors}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                />
              )}
              {currentStep === 3 && (
                <Step3 register={register} control={control} errors={errors} />
              )}
              {currentStep === 4 && (
                <Step4 register={register} control={control} errors={errors} />
              )}
              <Box className="stepsBtns">
                {currentStep === 1 && (
                  <ButtonStyledTb
                    type="button"
                    bg="var(--bg)"
                    border="var(--border)"
                    color="var(--lightGrey2)"
                  >
                    {t("back")}
                  </ButtonStyledTb>
                )}
                {currentStep > 1 && (
                  <ButtonStyledTb
                    type="button"
                    bg="var(--white)"
                    border="var(--lightGrey2)"
                    color="var(--themeColor)"
                    onClick={prev}
                  >
                    {t("back")}
                  </ButtonStyledTb>
                )}
                {currentStep < steps.length && (
                  <ButtonStyledTb
                    className="nextStepBtn"
                    type="button"
                    onClick={next}
                  >
                    {t("next")}
                  </ButtonStyledTb>
                )}
                {currentStep === 4 && (
                  <FormButtonStyled
                    type="submit"
                    bg="var(--themeColorSecondary)"
                    disabled={loading}
                    isLoading={loading}
                    label={t("Complete")}
                  />
                )}
              </Box>
            </Form>
          </Box>
        </RegContentWrapper>
      </RegistrationWrapper>
    </>
  );
};

export default Registration;
